import orderBy from './orderBy';

// TODO: remove when natural ordering supported by lodash
// https://github.com/lodash/lodash/pull/3764#issuecomment-419114339

export default orderBy;
